import { render, staticRenderFns } from "./ModalAddCertificate.vue?vue&type=template&id=312e6492&scoped=true&"
import script from "./ModalAddCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalAddCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e6492",
  null
  
)

export default component.exports